import React from "react";

import {
  SecondaryLink as BaseSecondaryLink,
  type SecondaryLinkProps
} from "@packages/ds";
import { Link as RouterLink } from "react-router";

const SecondaryLink = React.forwardRef<HTMLAnchorElement, SecondaryLinkProps>(
  (props, ref) => {
    const { analyticId, ...restProps } = props;
    if ("to" in restProps) {
      return (
        <BaseSecondaryLink
          ref={ref}
          {...restProps}
          as={RouterLink}
          data-pendo-identifier={analyticId}
        />
      );
    }
    return (
      <BaseSecondaryLink
        ref={ref}
        {...restProps}
        data-pendo-identifier={analyticId}
      />
    );
  }
);

SecondaryLink.displayName = "SecondaryLink";

export { SecondaryLink as default };
export type { SecondaryLinkProps };
